module.exports = __webpack_public_path__ + "img/Loop_de_Metodologia_Sixthsense.eb7baaf9.jpg";